import { render, staticRenderFns } from "./FooterTunnel.vue?vue&type=template&id=9147297a&"
import script from "./FooterTunnel.vue?vue&type=script&lang=js&"
export * from "./FooterTunnel.vue?vue&type=script&lang=js&"
import style0 from "./FooterTunnel.vue?vue&type=style&index=0&id=9147297a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterAppTop: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/FooterAppTop.vue').default,BrandLogo: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/BrandLogo.vue').default})
